import styled from 'styled-components';

const Img = styled.img`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || ''};
`;

export default Img;
